import React from 'react';

const FoundationFooter = () => {
  return (
    <footer className="w-full bg-gray-900 text-white py-8 md:py-12 px-4 md:px-8 text-center">
      <div className="max-w-6xl mx-auto">
        <p className="text-lg mb-4">
          © {new Date().getFullYear()} Fundación Sol Caribe. Todos los derechos reservados.
        </p>
        <div className="flex justify-center space-x-6">
          <a href="#" className="text-gray-400 hover:text-white transition-colors duration-300">
            Privacidad
          </a>
          <a href="#" className="text-gray-400 hover:text-white transition-colors duration-300">
            Términos
          </a>
          <a href="#" className="text-gray-400 hover:text-white transition-colors duration-300">
            Contacto
          </a>
        </div>
      </div>
    </footer>
  );
};

export default FoundationFooter;